/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RemixedTrackAggregate } from './RemixedTrackAggregate';
import {
    RemixedTrackAggregateFromJSON,
    RemixedTrackAggregateFromJSONTyped,
    RemixedTrackAggregateToJSON,
} from './RemixedTrackAggregate';

/**
 * 
 * @export
 * @interface UserTracksRemixedResponse
 */
export interface UserTracksRemixedResponse {
    /**
     * 
     * @type {Array<RemixedTrackAggregate>}
     * @memberof UserTracksRemixedResponse
     */
    data?: Array<RemixedTrackAggregate>;
}

/**
 * Check if a given object implements the UserTracksRemixedResponse interface.
 */
export function instanceOfUserTracksRemixedResponse(value: object): value is UserTracksRemixedResponse {
    let isInstance = true;

    return isInstance;
}

export function UserTracksRemixedResponseFromJSON(json: any): UserTracksRemixedResponse {
    return UserTracksRemixedResponseFromJSONTyped(json, false);
}

export function UserTracksRemixedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserTracksRemixedResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(RemixedTrackAggregateFromJSON)),
    };
}

export function UserTracksRemixedResponseToJSON(value?: UserTracksRemixedResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(RemixedTrackAggregateToJSON)),
    };
}

